// src/utils/pdfCertificado.js

import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"
import logoUrl from "@/assets/logo.png"

// ✅ Usa el mismo método que en reciboPdf.js
pdfMake.addVirtualFileSystem(pdfFonts)

export async function generarPDFCertificadoBase64(cert) {

  if (!cert.uuid && !cert.id) {
    throw new Error("El certificado no tiene un identificador válido (uuid o id).")
  }

  const logoDataUrl = await urlToDataURL(logoUrl)
  const valor = Number(cert.monto ?? cert.valor ?? 0)
  const codigo = cert.uuid || cert.id || ""

  const docDefinition = {
    pageSize: "A5",
    pageMargins: [30, 30, 30, 30],
    content: [
      logoDataUrl
        ? { image: logoDataUrl, width: 100, alignment: "center" }
        : null,

      { text: "CERTIFICADO DE REGALO", style: "header", margin: [0, 20, 0, 10] },
      { text: `Otorgado a: ${cert.destinatario?.nombre || "—"}`, fontSize: 12 },
      { text: cert.descripcion || "Certificado de regalo", margin: [0, 8, 0, 8] },

      // ✅ Protección para evitar crash si cert.monto es null/undefined
      { text: `Valor: $${valor.toFixed(2)}`, fontSize: 14, bold: true },

      cert.mensaje
        ? { text: cert.mensaje, italics: true, margin: [0, 10, 0, 10] }
        : null,

      cert.expiracion
        ? {
            text: `Válido hasta: ${new Date(cert.expiracion).toLocaleDateString("es-PR")}`,
            fontSize: 10,
          }
        : null,

      { text: `Código: ${codigo}`, fontSize: 10, margin: [0, 10, 0, 2] },

      {
        qr: JSON.stringify({
          id: codigo,
          tipo: cert.tipo || "monto",
          valor,
          descripcion: cert.descripcion || "Certificado de regalo"
        }),
        fit: 100,
        alignment: "center",
        margin: [0, 16, 0, 0]
      },


      {
        text: "Presenta este código al momento de redimir.",
        alignment: "center",
        fontSize: 9,
        margin: [0, 8, 0, 0]
      }
    ].filter(Boolean),

    styles: {
      header: {
        fontSize: 16,
        bold: true,
        alignment: "center",
        color: "#0f172a"
      }
    }
  }

  return await new Promise((resolve, reject) => {
    try {
      pdfMake.createPdf(docDefinition).getBase64(resolve)
    } catch (err) {
      reject(err)
    }
  })
}

async function urlToDataURL(url) {
  const res = await fetch(url)
  const blob = await res.blob()

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
